import apiProvider from './provider';
import { API_BASE_URL } from '../globals';
import { GET_MASTER_DATA, GET_CSS_FILE_NAME, GET_THEME } from './routes';
import { getAuthenticationHeaders, getErrorMessage, getOrgPrettyName } from './utils';
import { AxiosResponse } from 'axios';
import { ApiResponseWrapper } from './apiHandler';
export const getMasterData = async (params) => {

  try {
    const masterData: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(
      `${API_BASE_URL}${GET_MASTER_DATA}`,
      { params, headers: getAuthenticationHeaders() },
    );
    return {
      masterData: masterData.data.data,
      isSuccess: true,
    };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getCSSFileName = async () => {
  try {
    const organisationPrettyName = getOrgPrettyName();
    const fileNameResponse: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(`${API_BASE_URL}${GET_CSS_FILE_NAME}`, {
      headers: { 'organisation-pretty-name': organisationPrettyName }
      ,
    });
    return { isSuccess: true, filename: fileNameResponse.data.data };
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return { errorMessage, isSuccess: false };
  }
};

export const getThemeByOrganisationId = async () => {
  try {
    const themeStatus: any = await apiProvider.get(`${API_BASE_URL}${GET_THEME}`, {
      headers: { 'organisation-pretty-name': getOrgPrettyName() },
    });
    return { isSuccess: true, data: themeStatus.data.data };

  } catch (error) {
    const errorMessage = getErrorMessage(error);
    return { errorMessage, isSuccess: false };

  }
};
